export default __webpack_public_path__ + "static/media/featured-item-9.b02ff582.png";